const header = {
  header: {
    logOut: 'Déconnexion',
    enphaseStore: 'L’E-Store',
    enphaseSupport: 'Assistance Enphase ',
    comingSoon: 'Prochainement',
    new: 'Nouveau'
  }
};

export default header;
